import { Avatar, Box, Card, CardContent, Grid, Typography } from '@mui/material'
import { collection, getDocs } from 'firebase/firestore';
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { db } from '../../firebase/firebase';
import PermMediaIcon from '@mui/icons-material/PermMedia';

const TotalColecciones = (props) => {

    const [colecciones, setColecciones] = useState([]);
    const [usuarios, setUsuarios] = useState([]);

    useEffect(() => {
        obtenerColecciones();
        obtenerUsuarios();
    }, [])
    
    
    const obtenerUsuarios = async() =>{
        let arrayAux = [];

        const querySnapshot = await getDocs(collection(db, 'usuarios'))
        querySnapshot.docs.map( (doc) =>{
            arrayAux.push(doc.data());
        })
        setUsuarios(arrayAux);
    }


    const obtenerColecciones = async() =>{
        const querySnapshot = await getDocs(collection(db, 'colecciones'))
        const arrayData = querySnapshot.docs.map( doc => (
            {...doc.data()}
        ))
        setColecciones(arrayData);
    }


    return (
        
        <>
            <Card
                sx={{ height: '100%' }}
                {...props}
            >
                <CardContent>
                <Grid
                    container
                    spacing={3}
                    sx={{ justifyContent: 'space-between' }}
                >
                    <Grid item>
                        <Typography
                            color="textSecondary"
                            gutterBottom
                            variant="overline"
                        >
                            COLECCIONES CREADAS
                        </Typography>
                        <Typography
                            color="textPrimary"
                            variant="h4"
                        >
                            {colecciones.length}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Avatar
                            sx={{
                                backgroundColor: '#EC902E',
                                height: 56,
                                width: 56
                            }}
                        >
                            <PermMediaIcon />
                        </Avatar>
                    
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        pt: 2,
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    {/* <ArrowDownwardIcon color="error" /> */}
                    <Typography
                        sx={{
                            mr: 1
                        }}
                        variant="body2"
                        >
                        {Math.round(colecciones.length/usuarios.length)}.

                    </Typography>
                    <Typography
                        color="textSecondary"
                        variant="caption"
                    >
                        Aprox. por cada usuario
                    </Typography>
                </Box>
                </CardContent>
            </Card>
        </>

    )
}

export default TotalColecciones